import { ModelRow, UrlUtil } from "@mcleod/core";
import { DataHeaderProps, DataSourceMode, Table, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCallinScriptDetailTable } from "./autogen/AutogenLayoutCallinScriptDetailTable";

export class CallinScriptDetailTable extends AutogenLayoutCallinScriptDetailTable {
    private _tableCallinList: Table;

    public get tableCallinList(): Table {
        return this._tableCallinList;
    }

    public set tableCallinList(value: Table) {
        this._tableCallinList = value;
    }

    override onLoad(): void | Promise<void> {
        this.tableAddedPrompts.overrideUrlParams = (selectedRow: TableRow) => {
            return { key: selectedRow.data.get("callin_script_template.id"), idToSelect: selectedRow.data.get("id")}
        }
    }

    tableAddedPromptsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const id = tableRow.data.get("callin_script_template.id");
        tableRow.addDblClickListener(() => {
            const urlParams: string[] = [];
            urlParams.push("mode=" + "update");
            urlParams.push("detailIdToOpen=" + tableRow.data.get("id"));
            const url = "lme/dispatch/CallinScriptStepper" + UrlUtil.buildQueryString(urlParams);
            const crudDecoratorProps = { key: id, pseudoNavigateUrl: url };
            const dataHeaderProps: Partial<DataHeaderProps> = {
                onExecute: (_updatedRow: ModelRow) => {
                    this.tableCallinList.dataSource.search({});
                }
            }
            this.tableCallinList.crudManager.showCrud(DataSourceMode.UPDATE, crudDecoratorProps, dataHeaderProps);
        });

        const rowCount = this.tableAddedPrompts.rows.length.toString();
        if (this.labelPromptsTotal.text != rowCount) {
            this.labelPromptsTotal.text = rowCount;
        }
  }
}
